import { render, staticRenderFns } from "./CompanyClientEntry.vue?vue&type=template&id=530481f5&scoped=true&"
import script from "./CompanyClientEntry.vue?vue&type=script&lang=js&"
export * from "./CompanyClientEntry.vue?vue&type=script&lang=js&"
import style0 from "./CompanyClientEntry.vue?vue&type=style&index=0&id=530481f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530481f5",
  null
  
)

export default component.exports